import { render, staticRenderFns } from "./ToppingStatisticFragment.vue?vue&type=template&id=66d2cd0e&scoped=true&"
import script from "./ToppingStatisticFragment.vue?vue&type=script&lang=js&"
export * from "./ToppingStatisticFragment.vue?vue&type=script&lang=js&"
import style0 from "./ToppingStatisticFragment.vue?vue&type=style&index=0&id=66d2cd0e&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "66d2cd0e",
  null
  
)

export default component.exports